import { useTranslation } from 'react-i18next';
import { Badge } from '@parrot-software/design-system';

/**
 * AdvanceInvoiceBadge - Info badge shown when a block has advance invoicing.
 *
 * Matches the Figma "Factura anticipada" info badge (blue background/foreground,
 * no icon). Rendered only when the block's `advanceInvoice` flag is `true`.
 */
export const AdvanceInvoiceBadge = () => {
  const { t } = useTranslation('subscriptions');

  return (
    <Badge className="w-fit bg-bg-info text-info hover:bg-bg-info" variant="secondary">
      {t('badges.advanceInvoice')}
    </Badge>
  );
};
